import axios from '@/app/shared/config/interceptor'

const PREFIX = '/cards'

export default {

  getAllNotes (cardId) {
    return axios.get(`${PREFIX}/${cardId}/notes`)
  },
  createNote (cardId, description) {
    return axios.post(`${PREFIX}/${cardId}/notes`, description)
  },
  updateNote (cardId, id, newNote) {
    return axios.put(`${PREFIX}/${cardId}/notes/${id}`, newNote)
  },
  removeNote (cardId, id) {
    return axios.delete(`${PREFIX}/${cardId}/notes/${id}`)
  }
}
